var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.readyQuarter && _setup.builtYear ? _c('span', [_vm._v("\n  " + _vm._s(_setup.readyQuarter) + " " + _vm._s(_setup.quarterPostfix) + " " + _vm._s(_setup.builtYear) + "\n")]) : _setup.builtYear ? _c('span', [_vm._v("\n  " + _vm._s(_setup.builtYear) + "\n")]) : _c('span', [_vm._v("\n  " + _vm._s(_vm.empty) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };